/**
 *
 * Asynchronously loads the component for TaxPayerReport
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TaxpayerReport = lazyLoad(
  () => import('./index'),
  (module) => module.TaxPayerReport
);
